<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/41eo2S/tc-custom/1.png?1684979159015?1705540874293" alt="This image is the cover for the book The Monster in the Waves"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Monster in the Waves
      </h1>
      <p class="bookDescription body article font2">
        <p>Eden Bay is the perfect place and everyone who lives there helps to keep it that way.<br/>The only thing is that there is something in the water…the monster in the waves.<br/>No one dares to go into the water.<br/>Until the day Arlo steps in…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Brutnall
      </h2>
      
      <p class="authorDescription body article">Eric Brutnall has been a primary school teacher for 20 years and has enjoyed teaching hundreds of children. He loves to share his story ideas with his children and he takes inspiration from themes of how we can make the world a better place. Eric published his first book, The Hope Star, in January 2020. The Monster in the Waves is his second book. He lives in Maidenhead, UK.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3911b137